import React, {Component} from 'react';
import {connect} from 'react-redux';

import {t} from 'l10n';

import Loading from 'components/Loading';

import { 
    followProfile,
    unfollowProfile
} from 'reducers/member';

class MessageDialogAction extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingBlock: false,
            pendingFollow: false,
        };
    }

    onFollow() {
        const { dispatch } = this.props;
        const {
            user,
            followedByMe
        } = this.props.recipient;

        this.setState({pendingFollow: true})

        const action = followedByMe ? unfollowProfile(user.id) : followProfile(user.id);

        dispatch(action);

        action.promise
            .then(() => this.setState({pendingFollow: false}))
            .catch((e) => this.setState({pendingFollow: false}))
    }

    onBlock() {
        const { dispatch } = this.props;
        const {
            user,
            blacklistedByMe
        } = this.props.recipient;

        this.setState({pendingBlock: true})

        const action = blacklistedByMe ? unfollowProfile(user.id) : followProfile(user.id);

        dispatch(action);

        action.promise
            .then(() => this.setState({pendingBlock: false}))
            .catch((e) => this.setState({pendingBlock: false}))
    }

    render() {
        const { showModalBlacklist } = this.props;
        const {
            user,
            followedByMe,
            blacklistedByMe
        } = this.props.recipient;

        const { pendingFollow } = this.state;

        return (
            <div className="action-block">
                { pendingFollow ? <Loading /> : (
                    <div className={followedByMe ? 'unfollow' : 'follow'} onClick={() => this.onFollow()}>
                        <span>{followedByMe ? t('Unfollow') : t('Follow')}</span>
                    </div>
                )}
                <div className={blacklistedByMe ? 'unblock' : 'block'} onClick={showModalBlacklist}>
                    <span>{blacklistedByMe ? t('Unblock') : t('Block')}</span>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
    }), 
    null
)(MessageDialogAction);


// WEBPACK FOOTER //
// ./src/components/message/MessageDialogAction.js